// src/context/api.js
export const BASE_URL = 'http://142.93.247.219:5000';
